import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-servererror",
    templateUrl: "./servererror.component.html",
    styleUrls: ["./servererror.component.scss"],
    standalone: false
})
export class ServererrorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
